//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "VocServicerQr",
  //   props: {
  //     type: {
  //       type: String,
  //       default: "pc"
  //     }
  //   },
  data() {
    return {
      type: "pc"
    }
  },
  created() {
    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
      this.type = "mobile"
    }
  }
}
